import { createContext } from 'react';

import { InstallmentSettingsContextData } from './types';

export const InstallmentSettingsContext = createContext<InstallmentSettingsContextData>(
  {
    loading: false,
    disabled: true,
  },
);
